import { jsx as n } from "react/jsx-runtime";
import * as v from "react";
import { u as M, c as k, a as T } from "../../index-DcwNtM_b.js";
import { c as h, R as E, I as F } from "../../index-BJirOIk2.js";
import { P as $ } from "../../index-DBEov9sD.js";
import { P as m } from "../../index-CpDnqHCm.js";
import { u as D } from "../../index-TA5H0I__.js";
import { u as V } from "../../index-CDznMoQN.js";
import { c as p } from "../../utils-BOFVZgHd.js";
var g = "Tabs", [G, Y] = k(g, [
  h
]), C = h(), [L, x] = G(g), I = v.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: c,
      value: a,
      onValueChange: i,
      defaultValue: d,
      orientation: o = "horizontal",
      dir: u,
      activationMode: f = "automatic",
      ...b
    } = e, s = D(u), [r, l] = M({
      prop: a,
      onChange: i,
      defaultProp: d ?? "",
      caller: g
    });
    return /* @__PURE__ */ n(
      L,
      {
        scope: c,
        baseId: V(),
        value: r,
        onValueChange: l,
        orientation: o,
        dir: s,
        activationMode: f,
        children: /* @__PURE__ */ n(
          m.div,
          {
            dir: s,
            "data-orientation": o,
            ...b,
            ref: t
          }
        )
      }
    );
  }
);
I.displayName = g;
var y = "TabsList", _ = v.forwardRef(
  (e, t) => {
    const { __scopeTabs: c, loop: a = !0, ...i } = e, d = x(y, c), o = C(c);
    return /* @__PURE__ */ n(
      E,
      {
        asChild: !0,
        ...o,
        orientation: d.orientation,
        dir: d.dir,
        loop: a,
        children: /* @__PURE__ */ n(
          m.div,
          {
            role: "tablist",
            "aria-orientation": d.orientation,
            ...i,
            ref: t
          }
        )
      }
    );
  }
);
_.displayName = y;
var N = "TabsTrigger", R = v.forwardRef(
  (e, t) => {
    const { __scopeTabs: c, value: a, disabled: i = !1, ...d } = e, o = x(N, c), u = C(c), f = P(o.baseId, a), b = S(o.baseId, a), s = a === o.value;
    return /* @__PURE__ */ n(
      F,
      {
        asChild: !0,
        ...u,
        focusable: !i,
        active: s,
        children: /* @__PURE__ */ n(
          m.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": s,
            "aria-controls": b,
            "data-state": s ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: f,
            ...d,
            ref: t,
            onMouseDown: T(e.onMouseDown, (r) => {
              !i && r.button === 0 && r.ctrlKey === !1 ? o.onValueChange(a) : r.preventDefault();
            }),
            onKeyDown: T(e.onKeyDown, (r) => {
              [" ", "Enter"].includes(r.key) && o.onValueChange(a);
            }),
            onFocus: T(e.onFocus, () => {
              const r = o.activationMode !== "manual";
              !s && !i && r && o.onValueChange(a);
            })
          }
        )
      }
    );
  }
);
R.displayName = N;
var w = "TabsContent", A = v.forwardRef(
  (e, t) => {
    const { __scopeTabs: c, value: a, forceMount: i, children: d, ...o } = e, u = x(w, c), f = P(u.baseId, a), b = S(u.baseId, a), s = a === u.value, r = v.useRef(s);
    return v.useEffect(() => {
      const l = requestAnimationFrame(() => r.current = !1);
      return () => cancelAnimationFrame(l);
    }, []), /* @__PURE__ */ n($, { present: i || s, children: ({ present: l }) => /* @__PURE__ */ n(
      m.div,
      {
        "data-state": s ? "active" : "inactive",
        "data-orientation": u.orientation,
        role: "tabpanel",
        "aria-labelledby": f,
        hidden: !l,
        id: b,
        tabIndex: 0,
        ...o,
        ref: t,
        style: {
          ...e.style,
          animationDuration: r.current ? "0s" : void 0
        },
        children: l && d
      }
    ) });
  }
);
A.displayName = w;
function P(e, t) {
  return `${e}-trigger-${t}`;
}
function S(e, t) {
  return `${e}-content-${t}`;
}
var j = I, z = _, K = R, B = A;
function Z({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    j,
    {
      "data-slot": "tabs",
      className: p("flex flex-col gap-2", e),
      ...t
    }
  );
}
function ee({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    z,
    {
      "data-slot": "tabs-list",
      className: p(
        "bg-[var(--muted)] text-[var(--muted-foreground)] inline-flex h-9 w-fit items-center justify-center rounded-lg p-[3px]",
        e
      ),
      ...t
    }
  );
}
function te({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    K,
    {
      "data-slot": "tabs-trigger",
      className: p(
        "data-[state=active]:bg-[var(--background)] dark:data-[state=active]:text-[var(--foreground)] focus-visible:border-[var(--ring)] focus-visible:ring-[var(--ring)] focus-visible:outline-[var(--ring)] dark:data-[state=active]:border-[var(--input)] dark:data-[state=active]:bg-[var(--input)] text-[var(--foreground)] dark:text-[var(--muted-foreground)] inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-2 py-1 text-sm font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function ae({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    B,
    {
      "data-slot": "tabs-content",
      className: p("flex-1 outline-none", e),
      ...t
    }
  );
}
export {
  Z as Tabs,
  ae as TabsContent,
  ee as TabsList,
  te as TabsTrigger
};
//# sourceMappingURL=tabs.js.map
